
import {
  computed, defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import { Modal } from 'ant-design-vue';
import { useMagicKeys } from '@vueuse/core';
import { IPedidoCompraItem, IPedidoCompraItemImposto } from '@/models/Entidades/Compras/IPedidoCompra';
import { IColumn } from '@/core/models/AntDesign/IColumn';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { useFocusBase } from '@/core/composables/FocusBase';
import Icone from '@/core/components/Icone.vue';
import SelecionarProdutoMovimento from '@/components/Cadastros/Produtos/SelecionarProdutoMovimento.vue';
import SelecionarUnidadeProdutoMovimento from '@/components/Cadastros/Produtos/Unidades/SelecionarUnidadeProdutoMovimento.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import storeSistema from '@/store/storeSistema';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import PedidoCompraItemModal from '@/views/Compras/PedidoCompra/PedidoCompraItemModal.vue';

export default defineComponent({
  name: 'PedidoCompraItens',
  props: {
    empresa: {
      type: Number,
      required: true,
    },
    totalPedido: {
      type: Number,
      required: true,
    },
    itens: {
      type: Array as () => IPedidoCompraItem[],
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
    novoItem: {
      type: Boolean,
      default: false,
    },
    chaveItens: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Icone,
    SelecionarProdutoMovimento,
    SelecionarUnidadeProdutoMovimento,
    CampoNumerico,
    PedidoCompraItemModal,
  },
  emits: ['update:itens', 'atualizarItem', 'excluirItem', 'update:novoItem'],
  setup(props, { emit }) {
    let debounce = 0;
    let debounceRenderizarGrade = 0;

    const keys = useMagicKeys();
    const shiftN = keys['Shift+N'];

    const {
      focusBase, elementosFocaveis, obtemIndexElemento, focusElemento, proximoElemento, elementoAnterior, elementoAcima, elementoAbaixo,
    } = useFocusBase();
    focusBase.classElementos = 'ss-recebimento-mercadoria-itens';
    const state = reactive({
      colunasGrade: [] as IColumn[],
      indexItemSelecionado: -1,
      itemSelecionado: {} as IPedidoCompraItem,
      existeProximo: false,
      existeAnterior: false,
      exibirDetalhesItem: false,
      carregando: false,
      telaMobile: false,
      computedNovoItem: computed({
        get: () => props.novoItem,
        set: (val: boolean) => {
          emit('update:novoItem', val);
        },
      }),
    });

    function preencherColunas() {
      if (state.telaMobile) {
        state.colunasGrade = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
          },
          {
            title: 'Item', dataIndex: 'item', key: 'Item', position: 2, visible: true, ellipsis: true,
          },
        ];
      } else {
        state.colunasGrade = [
          {
            title: 'Produto', dataIndex: 'produto', key: 'Produto', position: 1, visible: true, width: 210, ordering: true, align: 'left', ellipsis: true,
          },
          {
            title: 'Unidade', dataIndex: 'unidade', key: 'Unidade', position: 2, visible: true, width: 40, ordering: false, align: 'center', ellipsis: true,
          },
          {
            title: 'Quantidade', dataIndex: 'quantidade', key: 'Quantidade', position: 3, visible: true, ordering: false, align: 'right', width: 70, ellipsis: true,
          },
          {
            title: 'Qtd Atendida', dataIndex: 'quantidadeAtendida', key: 'QuantidadeAtendida', position: 4, visible: true, ordering: false, align: 'right', width: 70, ellipsis: true,
          },
          {
            title: 'V. Unitário', dataIndex: 'valorUnitario', key: 'ValorUnitario', position: 5, visible: true, ordering: false, align: 'right', width: 70, ellipsis: true,
          },
          {
            title: 'IPI', dataIndex: 'ipi', key: 'Ipi', position: 6, visible: true, ordering: false, align: 'center', width: 40, ellipsis: true,
          },
          {
            title: 'Desconto', dataIndex: 'desconto', key: 'Desconto', position: 7, visible: true, ordering: false, align: 'right', width: 60, ellipsis: true,
          },
          {
            title: 'Valor Total', dataIndex: 'total', key: 'Total', position: 8, visible: true, ordering: false, align: 'right', width: 70, ellipsis: true,
          },
          {
            title: 'Status', dataIndex: 'status', key: 'Status', position: 8, visible: true, ordering: false, align: 'right', width: 70, ellipsis: true,
          },
          {
            title: 'Ações', key: 'acoes', position: 10, visible: true, fixed: 'right', width: 30, align: 'center', ellipsis: true,
          },
        ];
      }
    }

    const computedItens = computed({
      get: () => props.itens,
      set: (val: IPedidoCompraItem[]) => {
        emit('update:itens', val);
      },
    });

    function verificarSelecaoProduto() {
      console.log('Itens: ', computedItens.value);
    }

    function validarExisteProximoItem() {
      state.existeProximo = state.indexItemSelecionado < computedItens.value.length - 1;
    }

    function validarExisteItemAnterior() {
      state.existeAnterior = state.indexItemSelecionado > 0;
    }

    function instanciaNovoItem():IPedidoCompraItem {
      const itemPedidoCompra = {} as IPedidoCompraItem;
      itemPedidoCompra.imposto = {} as IPedidoCompraItemImposto;
      itemPedidoCompra.emDigitacao = false;
      itemPedidoCompra.codigoProdutoDefinicao = 0;
      itemPedidoCompra.unidade = 0;
      itemPedidoCompra.siglaUnidade = '';
      itemPedidoCompra.valorUnitario = 0;
      itemPedidoCompra.quantidade = 0;
      itemPedidoCompra.desconto = 0;
      itemPedidoCompra.valorTotal = 0;
      itemPedidoCompra.imposto.aliquotaIcms = 0;
      itemPedidoCompra.imposto.valorIcms = 0;
      itemPedidoCompra.imposto.aliquotaIpi = 0;
      itemPedidoCompra.imposto.valorIpi = 0;
      itemPedidoCompra.imposto.valorTotalTributos = 0;
      itemPedidoCompra.imposto.codigoNcm = 0;
      return itemPedidoCompra;
    }

    function adicionarItem() {
      state.indexItemSelecionado = -1;
      state.itemSelecionado = instanciaNovoItem();
      validarExisteProximoItem();
      validarExisteItemAnterior();
      state.exibirDetalhesItem = true;
    }

    function editarItem(index: number) {
      state.indexItemSelecionado = index;
      state.itemSelecionado = computedItens.value[index];
      validarExisteProximoItem();
      validarExisteItemAnterior();
      state.exibirDetalhesItem = true;
    }

    function proximoItem() {
      editarItem(state.indexItemSelecionado + 1);
    }

    function itemAnterior() {
      editarItem(state.indexItemSelecionado - 1);
    }

    function salvarItemGrade(index: number, item: IPedidoCompraItem) {
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        computedItens.value[index] = item;
        emit('atualizarItem', index);
      }, 600);
    }

    function salvarItem(item: IPedidoCompraItem) {
      if (state.indexItemSelecionado > -1) {
        computedItens.value[state.indexItemSelecionado] = item;
      } else {
        computedItens.value.push(item);
        state.indexItemSelecionado = computedItens.value.length - 1;
      }
      state.exibirDetalhesItem = false;
      emit('atualizarItem', state.indexItemSelecionado);
    }

    async function novoItemGrade(adicionar?: boolean) {
      const itens = props.itens;
      if (storeSistema.state.layoutMobile) {
        if (adicionar) {
          adicionarItem();
        }
      } else if (UtilitarioGeral.validaLista(itens)) {
        let ultimoIndex = 0;
        if (itens.length === 1) {
          ultimoIndex = 0;
        } else {
          ultimoIndex = itens.length - 1;
        }
        if (UtilitarioGeral.validaCodigo(itens[ultimoIndex].codigoProdutoDefinicao)) {
          const itemPedidoCompra = instanciaNovoItem();
          itens.push(itemPedidoCompra);
          computedItens.value = itens;
        }
      } else {
        const itemPedidoCompra = instanciaNovoItem();
        itens.push(itemPedidoCompra);
        computedItens.value = itens;
      }

      setTimeout(() => {
        focusElemento(elementosFocaveis.value.length - 6);
      }, 300);
    }

    onBeforeMount(async () => {
      state.telaMobile = UtilitarioDispositivo.larguraTelaMobile();
      preencherColunas();
      if (!state.telaMobile) { novoItemGrade(); }
    });

    watch(async () => state.computedNovoItem, async () => {
      if (state.computedNovoItem) {
        adicionarItem();
        state.computedNovoItem = false;
      }
    });

    watch(shiftN, () => {
      novoItemGrade();
    });

    async function excluirItem(index: number) {
      const codigoItem = computedItens.value[index].codigo;
      computedItens.value.splice(index, 1);
      emit('excluirItem', codigoItem);
    }

    async function confirmarExclusao(index: number, evento?:any) {
      if (UtilitarioGeral.validaCodigo(props.itens[index].codigoProdutoDefinicao)) {
        Modal.confirm({
          title: 'Você confirma a exclusão do item?',
          content: `${props.itens[index].descricaoProduto}`,
          okText: 'Sim',
          okType: 'danger',
          cancelText: 'Não',
          autoFocusButton: 'ok',
          onOk: async () => {
            let indexCampo = -1;
            const ultimoItem = (index === computedItens.value.length - 1);
            if (evento !== undefined) {
              indexCampo = obtemIndexElemento(evento);
            }
            await excluirItem(index);
            if (UtilitarioGeral.validaLista(computedItens.value)) {
              if (ultimoItem) {
                focusElemento(elementosFocaveis.value.length - 7);
              } else if (indexCampo !== undefined && indexCampo >= 0) {
                focusElemento(indexCampo);
              }
            }
          },
        });
      } else {
        await excluirItem(index);
      }
    }

    function verificaElementoEsquerda(emDigitacao:boolean, evento:any) {
      if (!emDigitacao) {
        elementoAnterior(evento);
      }
    }

    function verificaElementoDireita(emDigitacao:boolean, evento:any) {
      if (!emDigitacao) {
        proximoElemento(evento);
      }
    }
    function verificaElementoAcima(emDigitacao:boolean, evento:any, dataAttributeColuna:string) {
      if (!emDigitacao) {
        elementoAcima(evento, dataAttributeColuna);
      }
    }

    function verificaElementoAbaixo(emDigitacao:boolean, evento:any, dataAttributeColuna:string) {
      if (!emDigitacao) {
        elementoAbaixo(evento, dataAttributeColuna);
      }
    }

    function verificaElementoProximoElementoDesconto(emDigitacao: boolean, index: number, evento: any) {
      if (index === computedItens.value.length - 1) {
        novoItemGrade();
        clearTimeout(debounceRenderizarGrade);
        debounceRenderizarGrade = setTimeout(async () => {
          proximoElemento(evento);
        }, 150);
      } else {
        proximoElemento(evento);
      }
    }

    function obterStatusItem(index: number) {
      let descricao = '';
      if (computedItens.value[index].codigoProdutoDefinicao > 0 && !props.editavel) {
        const qtdRestante = computedItens.value[index].quantidade - (computedItens.value[index].quantidadeAtendida + computedItens.value[index].quantidadeCortada);
        if (qtdRestante === 0) {
          descricao = 'Concluido';
        } else if (qtdRestante === computedItens.value[index].quantidade) {
          descricao = 'Pendente';
        } else {
          descricao = 'Parcial';
        }
      }
      return descricao;
    }

    return {
      props,
      state,
      computedItens,
      adicionarItem,
      salvarItemGrade,
      salvarItem,
      proximoItem,
      itemAnterior,
      editarItem,
      confirmarExclusao,
      proximoElemento,
      elementoAnterior,
      elementoAcima,
      elementoAbaixo,
      verificaElementoEsquerda,
      verificaElementoDireita,
      verificaElementoAcima,
      verificaElementoAbaixo,
      verificaElementoProximoElementoDesconto,
      UtilitarioMascara,
      novoItemGrade,
      focusBase,
      verificarSelecaoProduto,
      obterStatusItem,
    };
  },
});
